import { render, staticRenderFns } from "./MilkTeaPage.vue?vue&type=template&id=3d5961b2&scoped=true&"
import script from "./MilkTeaPage.vue?vue&type=script&lang=js&"
export * from "./MilkTeaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5961b2",
  null
  
)

export default component.exports